import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngxs/store';
import { ChatsSelectors } from 'src/app/store/samwin/chats/chats.selectors';

@Injectable({
   providedIn: 'root',
})
export class TitleService {
   constructor(angularTitleService: Title, store: Store) {
      setTimeout(() => {
         store.select(ChatsSelectors.getTotalNumberOfUnreadMessages).subscribe((total) => {
            let title = 'samwin Web Agent';
            if (total) title = `(${total}) ${title}`;
            angularTitleService.setTitle(title);
         });
      });
   }
}
